import { branding, Colour_Tournament } from "./Utils";

export class CBChallenges {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "CBCHALLENGES";
    this.scene = "CBCHALLENGES";
    this.data = [];
    this.page = 7058;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = branding({ game: options.game, team: options.team, xml });
      xml = Colour_Tournament({ game: options.game, xml });

      // if (options.push_up) {
      //   xml.payload.field.find((item) => {
      //     return item.attr.name === "0000";
      //   }).value = "1";
      // } else {
      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0000";
        }).value = "0";
      } catch (err) {}
      // }
      xml.payload.field.find((item) => {
        return item.attr.name === "0000102";
      }).value =
        options.team?.variables?.alt_badge || options.team?.variables?.badge;

      xml.payload.field.find((item) => {
        return item.attr.name === "0000104";
      }).value = options.team?.short_name ?? options.team?.name;

      xml.payload.field.find((item) => {
        return item.attr.name === "0103";
      }).value =
        options.successful +
        parseInt(options.team?.variables?.successful_challenges ?? 0);

      xml.payload.field.find((item) => {
        return item.attr.name === "0203";
      }).value =
        options.unsuccessful +
        parseInt(options.team?.variables?.unsuccessful_challenges ?? 0);

      xml.payload.field.find((item) => {
        return item.attr.name === "0303";
      }).value =
        options.inconclusive +
        parseInt(options.team?.variables?.inconclusive_challenges ?? 0);

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
